module.exports = __webpack_public_path__ + "static/media/Z.7734d7f1.jpg";